export const endpoints = {
  PROFILE_UPDATE: "/api/profile/update",
  PROFILE_VIEW: "/api/profile/view",
}